import { useGetQuestionsQuery, useGetQuizQuery } from '@/modules/services';
import { Alert } from 'elmo-elements';
import React, { ReactElement, useEffect } from 'react';
import { useHistory, generatePath, useParams } from 'react-router-dom';
import QuizQuestionsRoutes, { QuestionParamType } from '../Questions/routes';

export const NoQuestion = (): ReactElement => {
  const { elearningId, questionId } = useParams<QuestionParamType>();
  const history = useHistory();
  const quiz = useGetQuizQuery(elearningId);
  const { data: questionsData } = useGetQuestionsQuery(
    {
      quizId: `${quiz.data?.id}`,
    },
    {
      skip: !quiz.data?.id || !quiz.data,
    },
  );

  useEffect(() => {
    /* Go to first question by default if available */
    if (questionsData && questionsData.length > 0) {
      const questionIds = questionsData.map((question) => question.id);

      const isValidQuestionId = questionIds.includes(questionId);
      history.push(
        generatePath(QuizQuestionsRoutes.path, {
          elearningId,
          questionId: isValidQuestionId ? questionId : questionsData[0].id,
        }),
      );
    }
  }, [questionsData, elearningId, history, questionId]);

  return (
    <Alert message="Quiz is not set up." type="info" isCloseable={false} />
  );
};

export default NoQuestion;
